var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"lang-switch__wrapper"},_vm._l((_vm.languages),function(lang,i){return _c('li',{key:`lang${i}`,staticClass:"lang-switch__item",class:{active: _vm.active == lang},attrs:{"data-lang":lang},on:{"click":_vm.switchLanguage}},[_vm._v(" "+_vm._s(lang)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }